<template>
    <div>
        <block-banner
            class="banner"
            image="3"
        />

        <block-section>
            <breadcrumb />
            <layout-split :headline="name">
                <template v-slot:primary>
                    <text-headline-secondary class="description" v-html="description" />

                    <block-fixedprice-ticket-product-information
                        v-if="product"
                        :product="product"
                        :show-description="false"
                    />
                </template>

                <template v-slot:secondary>
                    <form @submit.prevent="nextStep">
                        <div class="field">
                            <field-date-time />
                        </div>
                        <div class="field">
                            <field-passenger />
                        </div>

                        <text-button
                            class="next-button"
                            type="submit"
                            :disabled="!isStepValid"                            
                        >
                            <div v-if="isFree">
                                {{ $t("page_new_fixed_price_ticket.buttonFree") }}
                            </div>
                            <div v-else>
                                {{ $t("page_new_fixed_price_ticket.buttonBuy") }}
                            </div>
                        </text-button>
                    </form>
                </template>
            </layout-split>
        </block-section>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TextButton from "@/components/elements/TextButton";
import FieldDateTime from "@/components/fields/FieldDateTime";
import FieldPassenger from "@/components/fields/FieldPassenger";
import BlockFixedpriceTicketProductInformation from "@/components/blocks/BlockFixedpriceTicketProductInformation";
import paths from "@/router/paths";

import BlockBanner from "../components/blocks/BlockBanner";

export default {
    components: {
        TextButton,
        BlockBanner,
        BlockFixedpriceTicketProductInformation,
        FieldDateTime,
        FieldPassenger
    },
    computed: {
        ...mapGetters({
            isStepValid: "flow/isStepValid",
            passengers: "passenger/getPassengers"
        }),
        product() {
            if (!this.$route.query.productId) return null;

            return this.$store.state.products.fixedpriceticket.info.products.filter(
                p => p.id.toString() === this.$route.query.productId.toString()
            )[0];
        },
        name() {
            return this.product && this.product.texts[this.$i18n.locale].name;
        },
        description() {
            return (
                this.product &&
                this.product.texts[this.$i18n.locale].description
            );
        },
        image() {
            if (!this.product || !this.product.imageAvailable) {
                return 4;
            }
            return (
                process.env.VUE_APP_API_URL +
                "v1/products/fixedpriceticket/info/image?id=" +
                this.product.id
            );
        },
        isFree(){
        var passengerTypePrices = this.product.passengerTypePrices;
        var chosenPassengers = this.passengers;

        var totalPrice = 0;
        passengerTypePrices.map(
            passengerType => {
                var numberOfOccurences = 0;
                chosenPassengers.filter(function(passenger){
                    if(passenger.passengerType.id == passengerType.passengerTypeId){
                        numberOfOccurences = passenger.count;                      
                    }
                });
                totalPrice += passengerType.price * numberOfOccurences;
            }
        );
            return totalPrice == 0 && chosenPassengers.length > 0;
        }
    },
    watch: {
        $route: "initFlow"
    },
    created() {
        this.initFlow();
    },
    methods: {
        ...mapActions({
            nextStep: "flow/gotoNextStep"
        }),
        initFlow() {
            if (!this.product) {
                this.$router.replace(paths.fixedPriceProducts);
            } else {
                this.$store.dispatch("flow/startFixedPriceTicketFlow", {
                    product: this.product
                });
            }
        }
    }
};
</script>

<style scoped lang="scss">
.banner {
    height: 50vw;
    max-height: 300px;
}

.description {
    margin-bottom: 2rem;
}

.description ::v-deep a {
   font: 600 1.3rem "Fira Sans", Arial, Helvetica, sans-serif
}

.description ::v-deep p {
    margin: 0;
}

.next-button {
    display: block;
    width: 100%;
}

.field {
    margin-bottom: 1rem;
}

.prices {
    max-width: 180px;
}

h3 {
    font-weight: 700;
    font-size: 1rem;
    margin: 2rem 0 0 0;
}

@media (min-width: $breakpoint-tablet) {
    .field {
        margin-bottom: 1.5rem;
    }
}
</style>
